module.exports = __webpack_public_path__ + "static/media/UY.043b5473.png";